import { ComponentProps, FC, PropsWithChildren } from 'react';
import { Typography, TypographyProps } from 'antd';

const { Text: AntText } = Typography;

type TitleProps = PropsWithChildren<Partial<ComponentProps<TypographyProps['Text']>>>;

export const Text: FC<TitleProps> = ({ children, ...props }) => (
  <AntText {...props}>{children}</AntText>
);
